import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, useFormState } from 'react-final-form';
import { pushCheckoutStep as gtmPushCheckoutStep } from '../../../../../../utils/gtm';
import Address from '../../../../AddressAutocompleteSearch/Address';
import PersonalDetails from './PersonalDetails';
import Preferences from './Preferences';
import Campaigns from './Campaigns';
import Company from '../../../../../02_molecules/Company';

import styles from './index.module.scss';

const Details = ({
  withoutPhone,
  withoutAddress,
  preferencesToView,
  campaigns,
  campaignsRG,
  showCompanyDonation = false,
  campaign = '',
}) => {
  const form = useForm();
  const formState = useFormState();
  const [isCheckoutPushedToGtm, setIsCheckoutPushedToGtm] = useState(false);

  // GTM checkout push handler.
  const pushCheckoutToGtm = () => {
    if (!formState.values) {
      return;
    }
    const products = [
      {
        name: formState.initialValues.appeal_title,
        id: formState.initialValues.appeal_id,
        price: formState.values.amount[formState.values['donation_type']]
          ? formState.values.amount[formState.values['donation_type']]
          : '',
        category: 'Appeal',
        variant: formState.values['donation_type'],
        quantity: 1,
      },
    ];
    gtmPushCheckoutStep(1, 'Inline', products);
  };

  const onClick = () => {
    // Pushing checkout event to GTM.
    if (isCheckoutPushedToGtm) {
      return;
    }
    setIsCheckoutPushedToGtm(true);
    pushCheckoutToGtm();
  };

  return (
    <div className={styles['details']}>
      <div className={styles['details__container']}>
        <div className={styles['details__container-left']} onClick={onClick}>
          <div className={styles['details__title']}>Your name and email</div>
          <div className={styles['details__description']}>
            We&#39;ll email you a donation receipt
          </div>

          <PersonalDetails withoutPhone={withoutPhone} />

          {showCompanyDonation && (
            <div className={styles['details__company-wrapper']}>
              <Company />
            </div>
          )}

          {!withoutAddress && (
            <>
              <div className={styles['details__title']}>Your address</div>
              <div className={styles['details__description']}>
                Enter your address in the search box below
              </div>

              <Address />
            </>
          )}

          <Preferences
            setValue={form.mutators.setValue}
            preferencesToView={preferencesToView}
            addressIsDisplayed={!withoutAddress}
          />
          <Campaigns campaign={campaign} campaigns={campaigns} campaignsRG={campaignsRG} />
        </div>
      </div>
    </div>
  );
};

Details.propTypes = {
  withoutPhone: PropTypes.bool.isRequired,
  withoutAddress: PropTypes.bool.isRequired,
  preferencesToView: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      valueBackend: PropTypes.string,
      label: PropTypes.string,
      labelON: PropTypes.string,
    }),
  ).isRequired,
  campaigns: PropTypes.array.isRequired,
  campaignsRG: PropTypes.array.isRequired,
  showCompanyDonation: PropTypes.bool,
  campaign: PropTypes.string,
};

export default Details;
